<template>
  <div class="flex-grow-1">
    <b-button v-if="!userId && this.can.create" size="sm" block @click="showAuthModal">
      <b-icon icon="gear"/> Settings
    </b-button>

    <b-button v-if="this.can.create" v-b-toggle.visual-schedule-settings size="sm" block>
      <b-icon icon="gear"/> Settings
    </b-button>

    <b-sidebar
      @hidden="handleHidden"
      id="visual-schedule-settings"
      title="Settings"
      backdrop
      :right="position === 'right'"
      shadow
    >
      <div class="px-3 py-2">
        <ScheduleBuilder />
      </div>

      <template #footer>
        <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
          <b-button size="sm" variant="success" @click="save">Save</b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import { EventBus } from '../event-bus';
import ScheduleBuilder from './ScheduleBuilder.vue';

export default {
  components: { ScheduleBuilder },

  props: {
    position: {
      type: String,
      default: 'right',
    },
  },

  computed: {
    ...mapState(['userId', 'can']),
    ...mapGetters('demoMode', ['isActiveVisitorDemoing']),
  },

  methods: {
    ...mapMutations(['updateVisualScheduleContent', 'updateImageRevealerContent']),

    handleHidden() {
      this.updateVisualScheduleContent(true);
      this.updateImageRevealerContent(true);
    },

    showAuthModal() {
      EventBus.$emit('show-cta');
    },

    save() {
      if (this.isActiveVisitorDemoing) {
        this.$toast.open('In a real session, we would be saving the data.');
        return;
      }

      EventBus.$emit('update-schedule');
    },
  },
};
</script>
